// Firebase Collection keys
export const USERS_COLLECTION = "users";
export const REPORT_COLLECTION = "reports";
export const MATCH_COLLECTION = "matches";
export const AUDIT_COLLECTION = "audit";
export const CONFIG_COLLECTION = "config";
export const NOTIFICATION_COLLECTION = "notifications";
export const ELASTIC_SEARCH_INDEX = "people";
export function getUserPath(uid: string) {
  return [USERS_COLLECTION, uid].join("/");
}

export const MESSAGES_COLLECTION = "messages";
